import { render, staticRenderFns } from "./create-profile.component.html?vue&type=template&id=0c1d0689&scoped=true&external"
import script from "./create-profile.component.ts?vue&type=script&lang=ts&external"
export * from "./create-profile.component.ts?vue&type=script&lang=ts&external"
import style0 from "./create-profile.component.scss?vue&type=style&index=0&id=0c1d0689&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1d0689",
  null
  
)

export default component.exports